export default function ProcessSection() {
  const steps = [
    {
      number: '01',
      title: 'お申込み',
      description: '事業・法人の現況についてヒアリングを行うほか、販売に必要な資料を頂戴いたします。',
      icon: 'ri-file-text-line'
    },
    {
      number: '02',
      title: '販売開始',
      description: '買い手様の募集を行います。当然会社様が特定されるような情報は隠した形となります。',
      icon: 'ri-megaphone-line'
    },
    {
      number: '03',
      title: 'デューデリジェンス・交渉',
      description: 'まずは機密保持契約を結んだうえで、法人や事情に関する情報を開示していただきます。そのうえで買収サイドからデューデリジェンスを行って頂きます。',
      icon: 'ri-search-line'
    },
    {
      number: '04',
      title: '契約',
      description: '交渉がまとまりましたらご契約となります。',
      icon: 'ri-file-edit-line'
    },
    {
      number: '05',
      title: '譲渡',
      description: '契約に基づき、譲渡手続きが行われます。譲渡の内容によって、3か月～半年など、移行期間が発生する場合もございます。',
      icon: 'ri-hand-heart-line'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-6 py-3 bg-teal-50 rounded-full mb-6">
            <i className="ri-route-line text-teal-600 text-xl mr-3"></i>
            <span className="text-teal-600 font-bold text-sm">Process</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-6">
            お手続きの流れ
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            M&A成約までの5つのステップをご説明します
          </p>
        </div>

        {/* Steps */}
        <div className="relative">
          {/* Connection Line */}
          <div className="hidden lg:block absolute top-24 left-0 right-0 h-1 bg-gradient-to-r from-teal-500 via-cyan-500 to-teal-500" style={{ width: 'calc(100% - 200px)', left: '100px' }}></div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
            {steps.map((step, index) => (
              <div key={index} className="relative">
                <div className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 p-8 border-2 border-gray-100 hover:border-teal-500 group">
                  {/* Number Badge */}
                  <div className="relative z-10 w-16 h-16 bg-gradient-to-br from-teal-500 to-cyan-500 rounded-2xl flex items-center justify-center mb-6 mx-auto group-hover:scale-110 transition-transform duration-300">
                    <span className="text-2xl font-black text-white">{step.number}</span>
                  </div>

                  {/* Icon */}
                  <div className="w-14 h-14 bg-teal-50 rounded-xl flex items-center justify-center mb-4 mx-auto group-hover:bg-teal-100 transition-colors">
                    <i className={`${step.icon} text-3xl text-teal-600`}></i>
                  </div>

                  {/* Content */}
                  <h3 className="text-xl font-black text-gray-900 mb-3 text-center">{step.title}</h3>
                  <p className="text-sm text-gray-600 leading-relaxed text-center">{step.description}</p>
                </div>

                {/* Arrow for mobile */}
                {index < steps.length - 1 && (
                  <div className="lg:hidden flex justify-center my-4">
                    <i className="ri-arrow-down-line text-3xl text-teal-500"></i>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
